import { render, staticRenderFns } from "./savingpackages.vue?vue&type=template&id=632e1aac"
import script from "./savingpackages.vue?vue&type=script&lang=js"
export * from "./savingpackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports